import React from 'react';
import type { Language } from '../../types';
import { getTranslation } from '../../utils/translations';
import { formatDigitalCountdown } from '../../utils/intermittentFasting';
import CrescentMoonIcon from '../icons/CrescentMoonIcon';

interface FastingHeaderIndicatorProps {
    remainingMs: number;
    language?: Language;
    scheduled?: boolean;
    onClick: () => void;
}

const FastingHeaderIndicator: React.FC<FastingHeaderIndicatorProps> = ({
    remainingMs,
    language,
    scheduled = false,
    onClick,
}) => {
    const t = (key: Parameters<typeof getTranslation>[1]) => getTranslation(language, key);

    return (
        <button
            type="button"
            onClick={onClick}
            className={`flex items-center gap-1 px-1.5 sm:px-2.5 py-1 rounded-full border transition-all active:scale-95 shrink min-w-0 max-w-[5.5rem] sm:max-w-none ${
                scheduled
                    ? 'bg-indigo-50 dark:bg-indigo-950/40 text-indigo-700 dark:text-indigo-300 border-indigo-100 dark:border-indigo-900/60 hover:bg-indigo-100 dark:hover:bg-indigo-900/40'
                    : 'bg-teal-50 dark:bg-teal-950/40 text-teal-700 dark:text-teal-300 border-teal-100 dark:border-teal-900/60 hover:bg-teal-100 dark:hover:bg-teal-900/40'
            }`}
            aria-label={scheduled ? t('fastingScheduledTitle') : t('fastingOpenModal')}
        >
            <CrescentMoonIcon className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />
            <span className="text-[11px] font-bold tabular-nums leading-none truncate">
                {formatDigitalCountdown(remainingMs)}
            </span>
        </button>
    );
};

export default FastingHeaderIndicator;
